"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const keccak256_1 = __importDefault(require("keccak256"));
const merkletreejs_1 = __importDefault(require("merkletreejs"));
const presales_program_json_1 = __importDefault(require("./idl/presales_program.json"));
const spl_token_1 = require("@solana/spl-token");
const js_1 = require("@metaplex-foundation/js");
var ProgramId;
(function (ProgramId) {
    ProgramId["MAINNET"] = "sujDnCZxK6BjW3CsQGQDYem37biroURuDsREYtEEvTr";
    ProgramId["DEVNET"] = "sujDnCZxK6BjW3CsQGQDYem37biroURuDsREYtEEvTr";
    ProgramId["LOCALNET"] = "sujDnCZxK6BjW3CsQGQDYem37biroURuDsREYtEEvTr";
})(ProgramId || (ProgramId = {}));
class SDK {
    constructor(connection, wallet, programId) {
        this.idl = presales_program_json_1.default;
        this.TOKEN_METADATA_PROGRAM_ID = new web3_js_1.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
        this.connection = connection;
        this.wallet = wallet;
        this.provider = new anchor_1.AnchorProvider(this.connection, this.wallet, anchor_1.AnchorProvider.defaultOptions());
        this.program = new anchor.Program(this.idl, new web3_js_1.PublicKey(programId), this.provider);
    }
    static build(connection, wallet, network) {
        return __awaiter(this, void 0, void 0, function* () {
            let programId;
            switch (network) {
                case "mainnet":
                    programId = ProgramId.MAINNET;
                    break;
                case "devnet":
                    programId = ProgramId.DEVNET;
                    break;
                case "localnet":
                    programId = ProgramId.LOCALNET;
                    break;
            }
            return new SDK(connection, wallet, programId);
        });
    }
    static generateMerkleTree(users) {
        const tree = new merkletreejs_1.default(users.map((user) => user.toBuffer()), keccak256_1.default, {
            sortPairs: true,
            hashLeaves: true,
        });
        return {
            tree,
            root: tree.getRoot(),
        };
    }
    static getValidProof(tree, user) {
        const leaf = (0, keccak256_1.default)(user.toBuffer());
        const proof = tree.getProof(leaf);
        const validProof = proof.map((p) => p.data);
        return validProof;
    }
    /****************** Program Instructions ******************/
    initialize({ pricePerUnitInLamports, unitLots, maximumTotalUnits, maximumUnitsPerUser, startAt, solVault, merkleTreeRoot = Buffer.from(""), signer, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .initialize(unitLots, new anchor_1.BN(pricePerUnitInLamports), new anchor_1.BN(maximumTotalUnits), new anchor_1.BN(startAt), [...merkleTreeRoot], new anchor_1.BN(maximumUnitsPerUser))
                .accounts({
                payer: this.wallet.publicKey,
                systemProgram: anchor.web3.SystemProgram.programId,
                solVault,
                state: this.getStateAccount(),
                updateAuthority: this.getUpdateAuthority(),
            })
                .signers(signer === undefined ? [] : [signer])
                .rpc();
        });
    }
    initializeWhitelist() {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelist = web3_js_1.Keypair.generate();
            const tx = yield this.program.methods
                .initializeWhitelist()
                .preInstructions([
                yield this.program.account.whitelist.createInstruction(whitelist),
            ])
                .accounts({
                whitelist: whitelist.publicKey,
                payer: this.provider.publicKey,
                systemProgram: anchor.web3.SystemProgram.programId,
                state: this.getStateAccount(),
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
            })
                .signers([whitelist])
                .rpc();
            return {
                whitelist: whitelist.publicKey,
                tx,
            };
        });
    }
    createCollection({ signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // gemerate accounts for 1 NFT
            const rentInLamports = yield this.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
            const mint = web3_js_1.Keypair.generate();
            // find the associated token account
            const nftTokenAccount = (0, spl_token_1.getAssociatedTokenAddressSync)(mint.publicKey, payer);
            const whitelistAccount = yield this.getWhitelistAccount();
            const sig = yield this.program.methods
                .createCollection()
                .accounts({
                state: this.getStateAccount(),
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                whitelist: whitelistAccount,
                mintAuthority: payer,
                mint: mint.publicKey,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                metadata: this.getMetadataAccount(mint.publicKey),
                tokenAccount: nftTokenAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                updateAuthority: this.getUpdateAuthority()
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                }),
                web3_js_1.SystemProgram.createAccount({
                    fromPubkey: payer,
                    newAccountPubkey: mint.publicKey,
                    space: spl_token_1.MINT_SIZE,
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                    lamports: rentInLamports,
                }),
                (0, spl_token_1.createInitializeMintInstruction)(mint.publicKey, 0, payer, payer),
                (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, nftTokenAccount, payer, mint.publicKey)
            ])
                .signers(signer === undefined ? [mint] : [signer, mint])
                .rpc();
            return {
                mint: mint.publicKey,
                metadata: this.getMetadataAccount(mint.publicKey),
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                sig
            };
        });
    }
    updateCollection({ collection, collectionMetadata, collectionMasterEdition }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .updateCollection()
                .accounts({
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
                collection,
                collectionMetadata,
                collectionMasterEdition,
            })
                .rpc();
        });
    }
    setWhitelist(whitelist) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .setWhitelist()
                .accounts({
                whitelist,
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    addUserToWhitelist(user, whitelist) {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelistAccount = whitelist || (yield this.getWhitelistAccount());
            const stateAccount = this.getStateAccount();
            return yield this.program.methods
                .addUserToWhitelist(user)
                .accounts({
                whitelist: whitelistAccount,
                state: stateAccount,
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    addExistingUserToWhitelist({ user, whitelist, boughtUnits, redeemedUnits }) {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelistAccount = whitelist || (yield this.getWhitelistAccount());
            const stateAccount = this.getStateAccount();
            return yield this.program.methods
                .addExistingUserToWhitelist(user, new anchor_1.BN(boughtUnits), new anchor_1.BN(redeemedUnits))
                .accounts({
                whitelist: whitelistAccount,
                state: stateAccount,
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    buyUnits({ units, signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelistAccount = yield this.getWhitelistAccount();
            const vault = yield this.getVaultAccount();
            const state = this.getStateAccount();
            const updateAuthority = this.getUpdateAuthority();
            return yield this.program.methods
                .buy(new anchor_1.BN(units))
                .accounts({
                state,
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                updateAuthority,
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                })
            ])
                .signers(signer === undefined ? [] : [signer])
                .rpc();
        });
    }
    buyUnitsTransaction({ units, signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelistAccount = yield this.getWhitelistAccount();
            const vault = yield this.getVaultAccount();
            const state = this.getStateAccount();
            const updateAuthority = this.getUpdateAuthority();
            return yield this.program.methods
                .buy(new anchor_1.BN(units))
                .accounts({
                state,
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                updateAuthority,
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                })
            ])
                .signers(signer === undefined ? [] : [signer])
                .transaction();
        });
    }
    mintUnit({ signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // gemerate accounts for 1 NFT
            const rentInLamports = yield this.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
            const mint = web3_js_1.Keypair.generate();
            // find the associated token account
            const nftTokenAccount = (0, spl_token_1.getAssociatedTokenAddressSync)(mint.publicKey, payer);
            const state = yield this.getState();
            const whitelistAccount = yield this.getWhitelistAccount(state);
            const vault = yield this.getVaultAccount(state);
            const { collection, collectionMasterEdition, collectionMetadata } = yield this.getCollectionDetails(state);
            return yield this.program.methods
                .mint()
                .accounts({
                state: this.getStateAccount(),
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                mint: mint.publicKey,
                mintAuthority: payer,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                metadata: this.getMetadataAccount(mint.publicKey),
                tokenAccount: nftTokenAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                updateAuthority: this.getUpdateAuthority(),
                collection,
                collectionMasterEdition,
                collectionMetadata
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                }),
                web3_js_1.SystemProgram.createAccount({
                    fromPubkey: payer,
                    newAccountPubkey: mint.publicKey,
                    space: spl_token_1.MINT_SIZE,
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                    lamports: rentInLamports,
                }),
                (0, spl_token_1.createInitializeMintInstruction)(mint.publicKey, 0, payer, payer),
                (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, nftTokenAccount, payer, mint.publicKey)
            ])
                .signers(signer === undefined ? [mint] : [signer, mint])
                .rpc();
        });
    }
    mintUnitTransaction({ signer, payer = this.wallet.publicKey, recentBlockhash }) {
        return __awaiter(this, void 0, void 0, function* () {
            // generate accounts for 1 NFT
            const rentInLamports = yield this.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
            const mint = web3_js_1.Keypair.generate();
            // find the associated token account
            const nftTokenAccount = (0, spl_token_1.getAssociatedTokenAddressSync)(mint.publicKey, payer);
            const state = yield this.getState();
            const whitelistAccount = yield this.getWhitelistAccount(state);
            const vault = yield this.getVaultAccount(state);
            const { collection, collectionMasterEdition, collectionMetadata } = yield this.getCollectionDetails(state);
            const tx = yield this.program.methods
                .mint()
                .accounts({
                state: this.getStateAccount(),
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                mint: mint.publicKey,
                mintAuthority: payer,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                metadata: this.getMetadataAccount(mint.publicKey),
                tokenAccount: nftTokenAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                updateAuthority: this.getUpdateAuthority(),
                collection,
                collectionMasterEdition,
                collectionMetadata
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                }),
                web3_js_1.SystemProgram.createAccount({
                    fromPubkey: payer,
                    newAccountPubkey: mint.publicKey,
                    space: spl_token_1.MINT_SIZE,
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                    lamports: rentInLamports,
                }),
                (0, spl_token_1.createInitializeMintInstruction)(mint.publicKey, 0, payer, payer),
                (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, nftTokenAccount, payer, mint.publicKey)
            ])
                .signers(signer === undefined ? [mint] : [signer, mint])
                .transaction();
            tx.recentBlockhash = recentBlockhash;
            tx.feePayer = payer;
            tx.partialSign(mint);
            return tx;
        });
    }
    mintUnitIntruction({ signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // generate accounts for 1 NFT
            const rentInLamports = yield this.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
            const mint = web3_js_1.Keypair.generate();
            // find the associated token account
            const nftTokenAccount = (0, spl_token_1.getAssociatedTokenAddressSync)(mint.publicKey, payer);
            const state = yield this.getState();
            const whitelistAccount = yield this.getWhitelistAccount(state);
            const vault = yield this.getVaultAccount(state);
            const { collection, collectionMasterEdition, collectionMetadata } = yield this.getCollectionDetails(state);
            return yield this.program.methods
                .mint()
                .accounts({
                state: this.getStateAccount(),
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                mint: mint.publicKey,
                mintAuthority: payer,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                metadata: this.getMetadataAccount(mint.publicKey),
                tokenAccount: nftTokenAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                updateAuthority: this.getUpdateAuthority(),
                collection,
                collectionMasterEdition,
                collectionMetadata
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                }),
                web3_js_1.SystemProgram.createAccount({
                    fromPubkey: payer,
                    newAccountPubkey: mint.publicKey,
                    space: spl_token_1.MINT_SIZE,
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                    lamports: rentInLamports,
                }),
                (0, spl_token_1.createInitializeMintInstruction)(mint.publicKey, 0, payer, payer),
                (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, nftTokenAccount, payer, mint.publicKey)
            ])
                .signers(signer === undefined ? [mint] : [signer, mint])
                .instruction();
        });
    }
    mintUnitAdmin({ signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // gemerate accounts for 1 NFT
            const rentInLamports = yield this.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
            const mint = web3_js_1.Keypair.generate();
            // find the associated token account
            const nftTokenAccount = (0, spl_token_1.getAssociatedTokenAddressSync)(mint.publicKey, payer);
            const state = yield this.getState();
            const whitelistAccount = yield this.getWhitelistAccount(state);
            const vault = yield this.getVaultAccount(state);
            const { collection, collectionMasterEdition, collectionMetadata } = yield this.getCollectionDetails(state);
            return yield this.program.methods
                .mintAdmin()
                .accounts({
                state: this.getStateAccount(),
                payer,
                systemProgram: anchor.web3.SystemProgram.programId,
                vault,
                whitelist: whitelistAccount,
                mint: mint.publicKey,
                mintAuthority: payer,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                metadata: this.getMetadataAccount(mint.publicKey),
                tokenAccount: nftTokenAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                masterEdition: this.getMasterEditionAccount(mint.publicKey),
                updateAuthority: this.getUpdateAuthority(),
                collection,
                collectionMasterEdition,
                collectionMetadata
            })
                .preInstructions([
                web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
                    units: 1000000
                }),
                web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                    microLamports: 1
                }),
                web3_js_1.SystemProgram.createAccount({
                    fromPubkey: payer,
                    newAccountPubkey: mint.publicKey,
                    space: spl_token_1.MINT_SIZE,
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                    lamports: rentInLamports,
                }),
                (0, spl_token_1.createInitializeMintInstruction)(mint.publicKey, 0, payer, payer),
                (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, nftTokenAccount, payer, mint.publicKey)
            ])
                .signers(signer === undefined ? [mint] : [signer, mint])
                .rpc();
        });
    }
    verifyItem({ mint, signer, payer = this.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.getState();
            const { collection, collectionMasterEdition, collectionMetadata } = yield this.getCollectionDetails(state);
            const metaAccount = this.getMetadataAccount(mint);
            const accounts = {
                state: this.getStateAccount(),
                payer,
                metadata: metaAccount,
                tokenMetadataProgram: this.TOKEN_METADATA_PROGRAM_ID,
                updateAuthority: this.getUpdateAuthority(),
                collection,
                collectionMasterEdition,
                collectionMetadata
            };
            return yield this.program.methods
                .verifyItem()
                .accounts(accounts)
                .signers(signer === undefined ? [] : [signer])
                .rpc();
        });
    }
    end() {
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.getStateAccount();
            return yield this.program.methods
                .end()
                .accounts({
                state,
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.getStateAccount();
            return yield this.program.methods
                .start()
                .accounts({
                state,
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    updateRoot(merkleTreeRoot) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .updateRoot([...merkleTreeRoot])
                .accounts({
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    updateMaxUnitsPerUser(maxUnitsPerUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .updateMaxUnitsPerUser(new anchor_1.BN(maxUnitsPerUser))
                .accounts({
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    updateMaxUnits(maxUnits) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .updateMaxUnits(new anchor_1.BN(maxUnits))
                .accounts({
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    updateUnitPrice(newUnitPriceLamports) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.methods
                .updateUnitPrice(new anchor_1.BN(newUnitPriceLamports))
                .accounts({
                state: this.getStateAccount(),
                systemProgram: anchor.web3.SystemProgram.programId,
                payer: this.provider.publicKey,
            })
                .rpc();
        });
    }
    /****************** Account Methods ******************/
    getCollectionAccount(state = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            state = state || (yield this.getState());
            return state.collection;
        });
    }
    getCollectionDetails(state = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            state = state || (yield this.getState());
            return {
                collection: state.collection,
                collectionMetadata: state.collectionMetadata,
                collectionMasterEdition: state.collectionMasterEdition,
            };
        });
    }
    getState() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.program.account.state.fetch(this.getStateAccount()));
        });
    }
    getWhitelistAccount(state = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            state = state === undefined ? yield this.getState() : state;
            return state.whitelist;
        });
    }
    getWhitelist(state = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            const whitelistAccount = yield this.getWhitelistAccount(state);
            return (yield this.program.account.whitelist.fetch(whitelistAccount));
        });
    }
    getVaultAccount(state = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            state = state === undefined ? yield this.getState() : state;
            return state.vault;
        });
    }
    getStateAccount() {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("presale")], this.program.programId)[0];
    }
    getStateAccountWithBump() {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("presale")], this.program.programId);
    }
    getMetadataAccount(mint) {
        return (web3_js_1.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            this.TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            mint.toBuffer(),
        ], this.TOKEN_METADATA_PROGRAM_ID))[0];
    }
    getMasterEditionAccount(mint) {
        return (web3_js_1.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            this.TOKEN_METADATA_PROGRAM_ID.toBuffer(),
            mint.toBuffer(),
            Buffer.from("edition"),
        ], this.TOKEN_METADATA_PROGRAM_ID))[0];
    }
    getUpdateAuthority() {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("update")], this.program.programId)[0];
    }
    getUpdateAuthorityWithBump() {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("update")], this.program.programId);
    }
    /****************** Helper Methods ******************/
    getTransactionLogs(sig) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            return (_b = (_a = (yield this.connection.getTransaction(sig, {
                commitment: "confirmed",
            }))) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.logMessages;
        });
    }
    getNftsForUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const metaplex = new js_1.Metaplex(this.connection);
            const nfts = yield metaplex.nfts().findAllByOwner({
                owner: user
            });
            return nfts;
        });
    }
    getNftsForUpdateAuthority() {
        return __awaiter(this, void 0, void 0, function* () {
            const metaplex = new js_1.Metaplex(this.connection);
            const nfts = yield metaplex.nfts().findAllByUpdateAuthority({
                updateAuthority: this.getUpdateAuthority()
            });
            return nfts;
        });
    }
    /****************** Callbacks ******************/
    onStateChange(callback) {
        this.program.account.state.subscribe(this.getStateAccount()).on('change', (state) => {
            callback(state);
        });
    }
    onWhitelistChange(callback, whitelistAccounnt) {
        this.program.account.whitelist.subscribe(whitelistAccounnt).on('change', (whitelist) => {
            callback(whitelist);
        });
    }
}
exports.SDK = SDK;
